import { apiClient, getAuthHeader } from "./apiConfig";

export const fetchActiveTestimonials = async () => {
  const res = await apiClient.get(`/testimonials/active`);
  return res.data?.data || [];
};

export const fetchTestimonials = async () => {
  const res = await apiClient.get(`/testimonials/get_all`, getAuthHeader());
  return res.data?.data || [];
};

export const createTestimonial = async (payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return apiClient.post(`/testimonials/create`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const updateTestimonial = async (id, payload) => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  return apiClient.post(`/testimonials/update/${id}`, formData, {
    ...getAuthHeader(),
    headers: {
      ...getAuthHeader().headers,
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteTestimonial = async (id) => {
  return apiClient.delete(`/testimonials/delete/${id}`, getAuthHeader());
};
